module.exports = __webpack_public_path__ + "static/fonts/SaoChingcha-Bold.7f4d5a2.woff2";